import { get, isEmpty } from "lodash"
import { getIntradayPriceState, INTRADAY_PRICE_STATES } from "helpers/intraday-price-state"
import { INTRADAY_PRICE_COLUMN_DATA_PATHS } from "helpers/metrics"

const PRICE_AS_OF_FIELD = "priceAsOf"

interface PricedColumnMetric {
  dataPath: string
  baseDataPath?: string
}

interface GridRowParams {
  row: {
    isAggregation?: boolean
    contributor: {
      values?: Record<string, unknown>
      children?: Record<string, unknown>
      notHeld?: boolean
      isNoLongerHeld?: boolean
    }
  }
}

export function getVisibleIntradayPricePrefix(metricMetadata: PricedColumnMetric[] | null | undefined): string | null {
  // Prior-close row muting follows the first visible intraday price column's instrument
  // (e.g. "intraday-rebalanced", not a fixed "intraday"), so it applies only while that
  // column is on screen.
  const priceColumn = (metricMetadata ?? []).find(
    metric => INTRADAY_PRICE_COLUMN_DATA_PATHS.includes(metric.baseDataPath ?? metric.dataPath),
  )
  return priceColumn ? priceColumn.dataPath.split(".")[0] : null
}

export function isRowPricedOnPriorClose(params: GridRowParams, intradayPricePrefix: string | null): boolean {
  if (!intradayPricePrefix || params.row.isAggregation) {
    return false
  }
  const { contributor } = params.row
  if (contributor.notHeld || contributor.isNoLongerHeld || !isEmpty(contributor.children)) {
    return false
  }
  const rawPriceAsOf = get(contributor.values, [intradayPricePrefix, PRICE_AS_OF_FIELD])
  const priceAsOf = typeof rawPriceAsOf === "string" ? rawPriceAsOf : undefined
  return getIntradayPriceState(priceAsOf) === INTRADAY_PRICE_STATES.PRIOR
}
